// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel {
    'memberNumber': string;
    'debitCardAccountNumber'?: string;
    'debitCardNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel>> = [
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "debitCardAccountNumber",
            "baseName": "debitCardAccountNumber",
            "type":     "string"
        },
        {
            "name":     "debitCardNumber",
            "baseName": "debitCardNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel.attributeTypeMap;
    }
}
